export default __webpack_public_path__ + "static/media/Bruins.b91cd829.png";